// These consts are displayed during price increase periods when the FF is ON.
export const SUBSCRIPTION_PRICE_INCREASES = { seasonal: 69.99, annual: 219.99, annualBox: 54.99 };
export const PRICE_INCREASE_DATE = '4/11/24';
